import catalog from './weightUnits.json';

export const WEIGHT_UNITS = catalog.units;
const unitsById = new Map(WEIGHT_UNITS.map((unit) => [unit.value, unit]));

export const normalizeWeightConfig = (config) => {
  if (config.format !== 'weight') return { config: {} };
  if (!unitsById.has(config.weight_unit))
    return { error: 'Select a weight unit.' };
  return { config: { weight_unit: config.weight_unit } };
};

// Accepts an already formatted number. Unit selection never converts values.
// Legacy/incomplete metadata must not silently assign a physical unit.
export const appendWeightUnit = (amount, config) => {
  const unit =
    config?.format === 'weight' ? unitsById.get(config.weight_unit) : null;
  return unit ? amount + ' ' + unit.symbol : amount;
};
